<template>
  <div>
    <toast v-model="showToast" v-if="showToast" :msg="msg"></toast>
    <div v-if="hasDialog">
      <div v-if="showDialog" class="mask-wrapper" @click="onHideDialog">
        <img class="img" :src="receivedSuccessImgUrl" @click="onGoUse">
      </div>
    </div>
  </div>
</template>
<script>
import Toast from '@/components/Toast'
// 用于上报
import { getPromotionDetailForQ } from '@/services/promotion'
import { queryRedPacketStatus, receiveRedPacket, queryQunarRedpack, receiveQunarRedpack, doRedpacketFission, fetchRedpacketFission } from '@/services/q_redpack'
import { redBookQueryAuth, redBookReportProcess, BookReportScene } from '@/services/q_redbook_activity'
import { loginQ } from '@/utils/q_userinfo'
import sendLog from '@/utils/q_log'
import { checkUser, eventBusV } from '@/utils/q_hook'
import { openScheme, getSession, sessionKeys, getQueryString, throttle } from '@/utils/q_business'
import { Sniff } from '@/utils/q_sniff'
import { mpUtils } from '@tujia/fe-lib-bridge'
import { geocoder } from '@/services/city'
import { searchfilteritem } from '@/services/filter'
import urlHelper from '@lib/utils/urlHelper'
import { QShare } from '@/components/sharePopup'
import qunarRedirect from '@/utils/qunarRedirect'
import { trackReportLog } from '@/business/report'
export default {
  components: {
    Toast
  },
  mixins: [qunarRedirect],
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    },
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  data() {
    const { isQunarAppEnv } = this.platformEnv
    return {
      isQunarAppEnv,
      fId: Number(this.$route.query.fId),
      showToast: false,
      msg: '',
      showDialog: false,
      hasDialog: false,
      receivedSuccessImgUrl: '',
      currCoupon: null,
      timeOutArray: [],
      houseSet: []
    }
  },
  created() {
    if (this.isQInsideActivity) {
      redBookReportProcess({ identifyCode: this.$route.query.query, scene: BookReportScene.uv })
    }
  },
  computed: {
    isQInsideActivity() {
      // 测试环境： ['Q20240109153822'] 线上环境： ['Q20230814145029', 'Q20230628201204']
      return Sniff.isLogin && this.$route.query.query && this.$route.query.isMark === 'true' && ['Q20230814145029', 'Q20230628201204'].includes(this.$route.query.id)
    },
    isQ20220709101555() {
      return ['Q20220709101555'].indexOf(this.$route.query.id) > -1
    },
    isQ20230628201204() {
      return ['Q20230628201204', 'Q20230814145029'].indexOf(this.$route.query.id) > -1
    },
    isActiveFission() {
      return ['Q20230310140905'].indexOf(this.$route.query.id) > -1
    },
    isSharedPeople() { // 被分享者
      if (Sniff.uinfo && this.fId && this.fId !== Sniff.uinfo.uid) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    payLoad(newVal) {
      if (!newVal) {
        return
      }
      const logParam = {
        actPos: `${this.compIndex}_${newVal.redPackIndex}`,
        actPage: `cms_${this.$root.promotionId}`,
        actText: `cms_${this.$root.promotionId}_redPack`
      }

      // 分享红包在未领取情况下，唤起分享
      if (this.isActiveFission && newVal && newVal.shareRedPacket && newVal.status === 1) {
        loginQ().then(() => {
          if (this.isQunarAppEnv) {
            QShare()
          } else {
            this.$toast('请点击页面右上角进行分享')
          }
        }).catch((err) => { this.$toast(err) })
        return
      }

      if (newVal && newVal.toUse) {
        logParam.actText = `cms_${this.$root.promotionId}_redPack_useBtn`
        sendLog(logParam)
        setTimeout(() => { this.goList(newVal) }, 100)
        return
      }
      // 未领取
      if (newVal.status === 1) {
        // Q小红书活动授权弹窗
        if (this.isQInsideActivity) {
          loginQ().then(() => {
            redBookQueryAuth().then(res => {
              // 已授权
              if (!res && res.data && res.data.success) {
                // 授权过，不用再次授权
                this.fetchCoupon(newVal)
              } else if (res && res.status !== 0) {
                this.$toast(res.message || '查询授权失败, 请重试')
              } else {
                this.$emit('finish', {
                  type: 'showQActivityDialog',
                  data: {
                    confirm: () => {
                      redBookReportProcess({ identifyCode: this.$route.query.query, scene: BookReportScene.auth }).then(() => {
                        // 可以发券了
                        this.fetchCoupon(newVal)
                      })
                    },
                    cancel: () => { }
                  }
                })
              }
            }).catch(() => {
              this.$toast('授权失败，请重试')
            })
          })
        } else {
          this.fetchCoupon(newVal)
        }
      } else if (newVal.status === 3) {
        sendLog(logParam)
        // 渠道红包不支持立即使用功能
        if (newVal.channelType == 1) {
          return
        }
        this.goList(newVal)
      } else if (newVal.status === 4) {
        logParam.actText = `cms_${this.$root.promotionId}_redPack_noMore`
        sendLog(logParam)
        this.doShowToast('好可惜，红包抢完了')
      } else if (newVal.status === 5) {
        // 已使用
        // this.doShowToast('您已经使用过啦')
      }
      if (newVal.status === 0) {
        logParam.actText = `cms_${this.$root.promotionId}_redPack_unStart`
        sendLog(logParam)
        this.doShowToast('活动未开始，请稍后再试')
        this.throttleFetch()
      }
    }
  },
  mounted() {
    this.initRedPacket()
    eventBusV.$on('refresh_redpack', (content) => {
      if (content !== this.compIndex) {
        this.refreshRedpack()
      }
    })
    eventBusV.$on('houseSet', (houseSetArg) => {
      if (this.houseSet && houseSetArg && houseSetArg.items) {
        this.houseSet.push(...houseSetArg.items)
      }
    })
    this.throttleFetch = throttle(this.initRedPacket, 3000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    report(eventname, ext = {}) {
      try {
        trackReportLog(eventname, ext)
      } catch (err) {}
    },
    reportCouponReceive(isSuccess, requestParams, responseData) {
      this.report(isSuccess ? 'C_HOME_CMS_COUPON_RECEIVE_SUCCESS' : 'C_HOME_CMS_COUPON_RECEIVE_FAIL', {
        request_params: requestParams,
        response_data: responseData
      })
    },
    async initRedPacket() {
      const { items, privateProps } = this.compProps.mate || {}
      this.receivedSuccessImgUrl = (this.picHost + privateProps.receivedSuccessImgUrl) || ''
      this.hasDialog = privateProps.hasDialog
      let ids = []
      const uiItems = []
      const qunarItems = []
      const userType = await this.getUserType()
      items.forEach(async(redpacket) => {
        if (redpacket.channelType == 1) {
          const qunarList = []
          redpacket.qunarRedpack.forEach((item) => {
            if (item.type == 1) {
              const idAry = item.id.split(',')
              if (idAry.length == 2) {
                qunarList.push({
                  couponType: item.type,
                  couponId: idAry[1],
                  token: idAry[0]
                })
              }
            } else {
              qunarList.push({
                couponType: item.type,
                couponId: item.id
              })
            }
          })
          if (qunarList.length) {
            const resData = await queryQunarRedpack(qunarList)
            const qunarRedpackData = resData.data
            qunarItems.push({
              ...redpacket,
              receive: qunarRedpackData.code == 2,
              activityStatus: qunarRedpackData.code == 1 ? 2 : 3,
              activityType: 0,
              qunarList
            })
            this.$emit('init', qunarItems || [])
          }
          return
        }
        let item = null
        if (redpacket.userType && (userType === 1)) {
          item = redpacket.oldUser
        } else if (redpacket.userType && (userType === 2)) {
          item = redpacket.newUser
        } else {
          item = redpacket
        }
        if (item.id) {
          const idList = item.id.split(',')
          ids = ids.concat(idList)
          uiItems.push({
            ...item,
            flagId: idList[0]
          })
        }
      })
      if (ids.length) {
        const res = await queryRedPacketStatus(ids)
        const redPackData = res.value
        if (redPackData && redPackData.errcode === 0) {
          let redpackets = []
          if (redPackData.data?.redpacketActivities) {
            redPackData.data.redpacketActivities.forEach((item) => {
              const idx = uiItems.find((redpacket) => {
                return redpacket.flagId === item.activityConfigId
              })
              if (idx) {
                redpackets.push({
                  ...item,
                  ...idx
                })
              }
            })
          }

          // 活动裂变-被分享者，登录-打接口领取，给分享/被分享领
          if (this.isActiveFission && this.isSharedPeople && Sniff.isLogin) {
            redpackets.forEach((item) => {
              if (item.shareRedPacket) {
                this.doRedpacketFission(item)
              }
            })
          }

          // 查询活动裂变-老客+未领券+登陆状态
          if (this.isActiveFission && this.$root.isOldUser && Sniff.isLogin) {
            try {
              const count = await this.fetchRedpacketFission(redpackets)
              redpackets.forEach((item) => {
                if (!item.receive && item.shareRedPacket) {
                  item.fissionCount = count
                }
              })
            } catch (err) {}
          }

          this.beginTimeOut(redpackets)
          this.$emit('init', redpackets || [])
        } else {
          this.$emit('init', [])
        }
      }
    },

    doShowToast(msg) {
      this.msg = msg
      this.showToast = true
    },
    // 领券
    fetchCoupon(coupon) {
      const redpackedId = coupon.id
      try {
        // hack: 通过时间戳的方式，即使当前红包图片状态无改变，也能触发本组件的watch钩子
        this.$emit('finish', { type: 'updateUnLoginTimeStamp', data: { id: redpackedId } })
        loginQ().then(() => {
          const logParam = {
            actPos: `${this.compIndex}_${coupon.redPackIndex}`,
            actPage: `cms_${this.$root.promotionId}`,
            actText: `cms_${this.$root.promotionId}_receiveRedPack`
          }
          sendLog(logParam)
          // TOB-3521营销会场上报
          getPromotionDetailForQ(this.$root.promotionId)
          eventBusV.$emit('refresh_redpack', this.compIndex)
          if (coupon.channelType == 1) {
            this.fetchQunarCoupon(coupon)
            return
          }
          this.refreshRedpack()
          const requereRedPacketInfo = this.compProps.mate.privateProps.hasRedPackModel
          const redpackList = coupon.id.split(',').map((item) => {
            return {
              activityCode: item,
              couponCode: ''
            }
          })
          const requestParams = {
            redpackList,
            requereRedPacketInfo
          }
          receiveRedPacket(redpackList, requereRedPacketInfo).then((res) => {
            if (!res.value) {
              this.reportCouponReceive(false, requestParams, res)
              this.doShowToast('好可惜，红包抢完了')
              return
            }
            const value = res.value
            const { data = {} } = res.value
            const sendCouponRes = data.sendCouponRes || []
            this.reportCouponReceive(true, requestParams, res)
            switch (value.errcode) {
            case 0: {
              if (data && data.sendCouponRes) {
                // 判断是否都领取成功
                let resVo = sendCouponRes.length && sendCouponRes.every((item) => { return item.errorCode === 0 })
                if (resVo) {
                  if (this.isQInsideActivity) {
                    setTimeout(() => {
                      // Process接口调用间隔至少1500ms,否则会失败
                      redBookReportProcess({ identifyCode: this.$route.query.query, scene: BookReportScene.callback })
                    }, 1500);
                  }
                  if (requereRedPacketInfo) {
                    this.$emit('finish', { type: 'doRedpacketAndShowListToast', data: { id: redpackedId, recivedRepackList: data.redPacketInfos || [] } })
                    break
                  }
                  this.$emit('finish', { type: 'doRedpacket', data: { id: redpackedId } })
                  this.doShowDialog(coupon)

                  // 活动裂变，单个红包立即跳转
                  if (this.isActiveFission && redpackedId === 'BnbCt_vSaYL') {
                    setTimeout(() => { this.goList(coupon) }, 1000)
                  }

                  break
                } else {
                  const failVo = sendCouponRes.find((item) => { return item.errorCode !== 0 })
                  this.$toast(failVo?.errorMsg || '领取失败')
                  break
                }
              }
              break
            }
            case 165002: {
              this.doShowToast('已经领取过了')
              this.$emit('finish', { type: 'redpacketDone', data: { id: redpackedId } })
              break
            }
            case 165001: {
              this.doShowToast('好可惜，红包抢完了')
              this.$emit('finish', { type: 'overRedpacket', data: { id: redpackedId } })
              break
            }
            default:
              this.doShowToast(value.errmsg || '领取失败')
              break
            }
          }).catch((error) => {
            this.reportCouponReceive(false, requestParams, error)
          })
        }).catch(() => {
          const logParam = {
            actPos: `${this.compIndex}_${coupon.redPackIndex}`,
            actPage: `cms_${this.$root.promotionId}`,
            actText: `cms_${this.$root.promotionId}_receiveRedPack_onLogin`
          }
          sendLog(logParam)
          this.doShowToast('需要登录')
        })
      } catch (e) {
        const logParam = {
          actPos: `${this.compIndex}_${coupon.redPackIndex}`,
          actPage: `cms_${this.$root.promotionId}`,
          actText: `cms_${this.$root.promotionId}_receiveRedPack_onLogin`
        }
        sendLog(logParam)
        this.doShowToast('系统开小差了，一会再试试吧')
      }
    },

    /**
     * 活动裂变，老客-获取领券人数
     */
    async fetchRedpacketFission(redpackets) {
      let one = ''
      redpackets.forEach((item) => {
        if (!item.receive && item.shareRedPacket) {
          one = item.id
        }
      })
      if (one === '') {
        return
      }
      try {
        const ret = await fetchRedpacketFission([one])
        return ret?.value?.data?.fissionData[one] || 0
      } catch (err) { return 0 }
    },

    /**
     * 派发红包
     */
    async doRedpacketFission(coupon) {
      const redpackedId = coupon.id
      try {
        const redpackList = coupon.id.split(',').map((item) => {
          return {
            activityCode: item,
            couponCode: ''
          }
        })
        const ownerMemberId = this.fId
        doRedpacketFission(redpackList, '', ownerMemberId).then((res) => {
          if (res && res.value) {
            const { data = {} } = res.value
            if (data.success) {
              this.$emit('finish', { type: 'doRedpacket', data: { id: redpackedId } })
            }
          }
        })
      } catch (e) { console.log(e) }
    },

    async fetchQunarCoupon(coupon) {
      try {
        const resData = await receiveQunarRedpack(coupon.qunarList)
        const code = resData.data && resData.data.code || -1
        switch (code) {
        case 6: {
          this.doShowToast('领取成功')
          this.initRedPacket()
          break
        }
        case 7: {
          this.doShowToast('好可惜，红包抢完了')
          this.initRedPacket()
          break
        }
        }
      } catch (error) {
        this.doShowToast('系统开小差了，一会再试试吧')
      }
    },

    async refreshRedpack() {
      await checkUser()
      this.initRedPacket()
    },

    doShowDialog(coupon) {
      if (!this.hasDialog) {
        if (['Q20220709101555'].indexOf(this.$route.query.id) > -1) {
          this.$dialog({
            title: '领取成功！',
            message: '支持“京郊住宿券”的乡村民宿可用～',
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '关闭'
          })
        } else {
          if (this.isActiveFission && coupon.id === 'BnbCt_vSaYL') {
            this.doShowToast('参加成功，去选好房吧')
          } else {
            this.doShowToast('领取成功')
          }
        }
        return
      }
      this.showDialog = true
      this.currCoupon = coupon
    },

    async goList(coupon) {
      // const sessionUrl = getSession(sessionKeys.JUMP_LIST_URL)
      // let url = `${sessionUrl}&fromPage=cms_${this.$root.promotionId}&refPage=cms_${this.$root.promotionId}`
      const channelId = this.$route.query.code || `cms_${this.$root.promotionId}_redpacket`
      const exclusiveHouse = this.$route.query.exclusiveHouse
      if (this.isQ20220709101555) {
        let url = `https://m.tujia.com/hotel_beijing/6-4168/?code=${channelId}`
        const rnParams = encodeURIComponent(JSON.stringify({
          param: {
            id: 48,
            url: 'https://m.tujia.com/gongyu/beijing/?cityId=48&cds=6_4168',
            channelId
          }
        }))
        if (Sniff.isRN) {
          window.location.href = `${Sniff.scheme}://react/open?hybridId=bnbrn&pageName=SearchList&initProps=${rnParams}`
        } else if (Sniff.miniprogram) {
          mpUtils.navigateTo({
            url: `/pages/tbnb/pages/common/webview/index?h5url=${encodeURIComponent(url)}`
          })
        } else {
          window.location.href = url
        }
        return
      }
      if (this.isQ20230628201204) {
        const findHouseInfo = this.houseSet?.find((item) => item.unitId === Number(exclusiveHouse)) || {}
        let url = `${coupon.activeLink.replace('HOUSEID', exclusiveHouse).replace('CITYID', findHouseInfo.cityId)}&code=${channelId}`
        const rnParams = encodeURIComponent(JSON.stringify({
          param: {
            id: findHouseInfo.cityId || 48,
            url: `https://m.tujia.com/gongyu/beijing/?cityId=${findHouseInfo.cityId}&cds=9_${exclusiveHouse}`,
            channelId
          }
        }))
        if (Sniff.isRN) {
          window.location.href = `${Sniff.scheme}://react/open?hybridId=bnbrn&pageName=SearchList&initProps=${rnParams}`
        } else if (Sniff.miniprogram) {
          mpUtils.navigateTo({
            url: `/pages/tbnb/pages/common/webview/index?h5url=${encodeURIComponent(url)}`
          })
        } else {
          window.location.href = url
        }
        return
      }

      // 处理activeLink/mpLink
      let url = `https://m.tujia.com/hotel_beijing/?code=${channelId}`
      let CITYREG = new RegExp(/CITYID/, 'g')
      let geoInfo = await geocoder({ parameter: {} })
      let urlobj = urlHelper.getQueryStringByStringUrl(coupon.activeLink)
      let isSupportFilter = await searchfilteritem({ cityId: (geoInfo && geoInfo.data && geoInfo.data.cityId) || 48, filterValue: urlobj.cds || '' })
      let cityId = isSupportFilter.data && isSupportFilter.data.filterItem ? geoInfo.data.cityId : 48
      let cityName = isSupportFilter.data && isSupportFilter.data.filterItem ? geoInfo.data.cityName : '北京'
      let isOverSea = isSupportFilter.data && isSupportFilter.data.filterItem ? geoInfo.data.oversea ? 2 : 1 : 1
      let _maplink = coupon.mpLink && coupon.mpLink.replace(CITYREG, cityId).replace('城市名称', cityName).replace('城市类型', isOverSea)

      // 兼容目前线上活动
      let appUrl = ''
      let isOldUrl = false
      if (coupon.appLink.indexOf('app.tujia.com') > -1) {
        isOldUrl = true
      }
      if (isOldUrl) {
        // Qapp RN 跳转RN列表页
        const params = {
          param: {
            channelid: channelId
          }
        }
        appUrl = `${Sniff.scheme}://react/open?hybridId=bnbrn&pageName=SearchList&initProps=${encodeURIComponent(JSON.stringify(params))}`
      } else {
        // 处理appLink，加channelId
        let propsObj = getQueryString('initProps', coupon.appLink) ? JSON.parse(getQueryString('initProps', coupon.appLink)) : {}
        if (!propsObj.param) {
          propsObj.param = {
            channelId: channelId
          }
        } else if (propsObj.param && !propsObj.param.channelId) {
          propsObj.param.channelId = channelId
        }
        appUrl = Sniff.scheme + '://' + this.setQueryParamValue(coupon.appLink, 'initProps', propsObj)
      }

      let redirectUrl = {
        activeLink: coupon.activeLink && coupon.activeLink.replace(CITYREG, cityId),
        appLink: appUrl.replace(Sniff.scheme + '://', ''),
        mpLink: _maplink
      }
      this.redirectTo(redirectUrl)
      // if (Sniff.miniprogram && redirectUrl.activeLink) {
      //   const haveChannelId = redirectUrl.activeLink.search('channelId=')
      //   let mUrl = haveChannelId !== -1 ? redirectUrl.activeLink : (redirectUrl.activeLink + `&code=${channelId}`)
      //   mpUtils.navigateTo({
      //     url: `/pages/tbnb/pages/common/webview/index?h5url=${encodeURIComponent(mUrl)}`
      //   })
      //   return
      // } else if (Sniff.qunar && redirectUrl.appLink) {
      //   window.hysdk.schemeForResult({
      //     scheme: redirectUrl.appLink
      //   })
      //   return
      // } else if (redirectUrl.activeLink) {
      //   const haveChannelId = redirectUrl.activeLink.search('channelId=')
      //   url = haveChannelId !== -1 ? redirectUrl.activeLink : (redirectUrl.activeLink + `&code=${channelId}`)
      // }
      // setTimeout(() => openScheme(url), 20)
      // if (coupon.useUrl) {
      //   url = coupon.useUrl
      // } else if (Sniff.isRN) {
      //   // Qapp RN 跳转RN列表页
      //   const params = {
      //     param: {
      //       channelid: channelId
      //     }
      //   }
      //   const crnUrl = `${Sniff.scheme}://react/open?hybridId=bnbrn&pageName=SearchList&initProps=${encodeURIComponent(JSON.stringify(params))}`
      //   window.hysdk.schemeForResult({
      //     scheme: crnUrl
      //   })
      //   return
      // }
    },

    // 替换initProps
    setQueryParamValue(appLink, key, newValue) {
      let appLinkParam = appLink.split('?') || []
      let queryString = ''
      if (appLinkParam.length > 0) {
        queryString = appLink.split('?')[1] || ''
      }
      let newParam = key + '=' + encodeURIComponent(JSON.stringify(newValue))
      let replaced = false
      let params = queryString.split('&')
      for (let i = 0; i < params.length; i++) {
        if (params[i].split('=')[0] == key) {
          params[i] = newParam
          replaced = true
        }
      }
      if (replaced) { return appLinkParam[0] + '?' + params.join('&') }
      return appLinkParam[0] + '?' + params.join('&') + '&' + newParam
    },

    onHideDialog() {
      this.showDialog = false
    },

    onGoUse() {
      this.showDialog = false
      const logIndex = (this.currCoupon && this.currCoupon.redPackIndex) || 0
      const logParam = {
        actPos: `${this.compIndex}_${logIndex}_0`,
        actPage: `cms_${this.$root.promotionId}`,
        actText: `cms_${this.$root.promotionId}_redPack_goUse`
      }
      sendLog(logParam)
      this.goList(this.currCoupon)
      this.currCoupon = null
    },

    async getUserType() {
      const userType = getSession(sessionKeys.IS_OLD_USER)
      if (userType) {
        return userType
      }
      await checkUser()
      return getSession(sessionKeys.IS_OLD_USER)
    },

    beginTimeOut(redpackets) {
      redpackets.forEach((item) => {
        if (item.activityType === 3 && item.activityStatus === 1) {
          this.timeOutArray.push(parseInt(item.countDown / 1000, 10))
        }
      })
      if (this.timeOutArray.length) {
        this.timeOuntRun()
      }
    },

    timeOuntRun() {
      this.timer = setInterval(this.calculTime, 1000)
    },

    calculTime() {
      this.timeOutArray.forEach((item, index) => {
        this.timeOutArray[index] = item - 1
        if (item === 0) {
          this.initRedPacket()
        }
      })
      this.timeOutArray.filter((item) => {
        return item > 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.mask-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  .img {
    width: 75%;
  }
}
</style>
